// extracted by mini-css-extract-plugin
export default {"container":"Home_container__n2OLi","mainPage":"Home_mainPage__eS9IG","heading":"Home_heading__AaXMc","text":"Home_text__ccuR6","imageGallery":"Home_imageGallery__djZUg"};